import {Component} from '@angular/core';
import {ProfileService} from '../../services/profile.service';
import {Toast} from 'ngx-toastr';


@Component({
    // tslint:disable-next-line:component-selector
    selector: '[app-rgpd-notif]',
    imports: [],
    templateUrl: './rgpd-notif.component.html',
    styleUrls: ['./rgpd-notif.component.css']
})
export class RgpdNotifComponent extends Toast {

  constructor(private profileService: ProfileService) {
    super();
  }

  readRgpd(): void {
    this.profileService.readRgpd();
    this.remove();
  }

}
